import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

/**
 * Check if current path is any dashboard route
 */
export const isDashboardRoute = (pathname: string): boolean => {
	return (
		pathname.startsWith(RoutesHelper.getAccessibilityDashboardPath()) ||
		pathname.startsWith(RoutesHelper.getBusinessUnitDashboardPath())
	);
};

/**
 * Check if current path is business units route
 */
export const isBusinessUnitsRoute = (pathname: string): boolean => {
	return pathname.startsWith(RoutesHelper.getBusinessUnitDashboardPath());
};

/**
 * Extract unit ID from business units path
 */
export const extractUnitIdFromPath = (pathname: string): string | null => {
	const businessUnitsPath = RoutesHelper.getBusinessUnitDashboardPath();
	if (!pathname.startsWith(businessUnitsPath)) {
		return null;
	}

	// Remove the base path and any leading slashes
	const remainingPath = pathname.replace(businessUnitsPath, '').replace(/^\/+/, '');

	// Remove trailing slashes and return the unit ID
	const unitId = remainingPath.replace(/\/+$/, '');

	// If there's a remaining path, it should be the unit ID
	return unitId || null;
};
